import useSWR from "swr";
import { Paginated, PaginationQuery } from "../../types";
import { buildUrl, useApi } from "../api";
import { CustomError } from "../errors";
import { ServiceClassLight } from "./types";

export const useServiceClasses = (query: PaginationQuery, signal: AbortSignal, isAdmin?: boolean) => {
  const api = useApi();
  const prefix = isAdmin ? "/admin" : "";
  const url = buildUrl(`${prefix}/modules/lock_calculator/selects/service_classes`, query);
  return useSWR<Paginated<ServiceClassLight>, CustomError, string>(url, (requestUrl) =>
    api.get<Paginated<ServiceClassLight>>({ url: requestUrl, signal }),
  );
};
